// import axios from "@/axiosInterceptor";

const state = () => ({
  steps: [],
  // activeStep: { identifier: 'Classifications', title: 'Classifications', step: 1, subStep: 1, subStepTotal: 1, stage: 'Identity' },
  // activeStepIndex: 0,
  activeStep: {
    identifier: 'Identity-1',
    title: 'Identity',
    step: 1,
    subStep: 1,
    subStepTotal: 4,
    stage: 'Identity',
  },
  activeStepIdentifier: 'Identity-1',
  activeStepIndex: 1,
  stepTransitionName: 'slide-fade',
  stepDirection: 'forward',
  initialHit: null,
  classificationsNextIdentifier: null,
  redirectToClassifications: false,
  beginningStepIdentifier: 'Identity-1',
  onboardingPacketViewIsMounted: false,
  errorOnNextStepPatch: false,
});

// getters

const getters = {
  // activeStepIdentifier: state => {
  //   return state.activeStep?.identifier;
  // },
};

// actions

const actions = {
  async updateActiveStep({ commit }, val) {
    await commit('setActiveStep', val);
  },
  async updateActiveStepIdentifier({ commit }, val) {
    await commit('setActiveStepIdentifier', val);
  },
  async updateActiveStepIndex({ commit }, val) {
    await commit('setActiveStepIndex', val);
  },
  async updateStepTransition({ commit }, val) {
    await commit('setStepTransition', val);
  },
  async markInitialHit({ commit }, val) {
    await commit('setInitialHit', val);
  },
  async redirectToBeginningStep({ state, dispatch }) {
    const beginningStep = state.steps.find(
      (step) => step.identifier == state.beginningStepIdentifier
    )?.[0];
    await dispatch('updateActiveStep', beginningStep);
    await dispatch('updateActiveStepIndex', state.steps.indexOf(beginningStep));
    await dispatch('updateActiveStepIdentifier', beginningStep?.identifier);
  },
};

//mutations
const mutations = {
  setActiveStep(state, val) {
    state.activeStep = val;
  },
  setActiveStepIdentifier(state, val) {
    state.activeStepIdentifier = val;
  },
  setActiveStepIndex(state, val) {
    state.activeStepIndex = val;
  },
  setStepTransition(state, val) {
    if (val == 'default') {
      state.stepTransitionName = 'slide-fadeup';
    } else if (val == 'forward') {
      state.stepTransitionName = 'slide-fade';
    } else if (val == 'back') {
      state.stepTransitionName = 'reverse-slide-fade';
    }
  },
  setStepDirection(state, val) {
    state.stepDirection = val;
  },
  setInitialHit(state, val) {
    console.log('formRoutes: initialHit at ' + val);
    state.initialHit = val;
  },
  setClassificationsNextIdentifier(state, val) {
    state.classificationsNextIdentifier = val;
  },
  setRedirectToClassifications(state, bool) {
    state.redirectToClassifications = bool;
  },
  setOnboardingPacketViewIsMounted(state, bool) {
    state.onboardingPacketViewIsMounted = bool;
  },
  setErrorOnNextStepPatch(state, bool) {
    state.errorOnNextStepPatch = bool;
  },
  setSteps(state, val) {
    state.steps = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
